import React from 'react';
import { Icon } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';
import { firstErrorMessage } from '@/utils/errors';
import { requestWorkspaceStates } from '../constants';
import { requestWorkspaceIcon } from '../helper';

const RequestWorspaceIconMessage = ({
  defaultStatus = requestWorkspaceStates.CHECKING,
  icon,
  request,
  verbose,
}) => {
  const settings = requestWorkspaceIcon(request, defaultStatus);
  const error = verbose && settings.status === requestWorkspaceStates.ERROR
    ? firstErrorMessage(request.workspaceReadErrors)
    : null;

  return (
    <>
      <Icon name={settings.loading ? 'circle notched' : icon || settings.icon} loading={settings.loading} />
      {error && (<>{error}</>)}
      {!error && (<FormattedMessage id={verbose ? `${settings.message}.verbose` : settings.message} />)}
    </>
  );
};

export default RequestWorspaceIconMessage;
